<template>
  <draggable
      class="Item_sort"
      tag="ul"
      :list="categories"
      :child="child"
      :group="{ name: 'g1', put: false }"
      item-key="name"
      @sort="changeSort(categories)"
  >
    <template #item="{ element }">
      <li v-if="element.sub_categories && element.sub_categories.length > 0"
          :class="child ? 'pa_0 transparent_bg' : ''">
        <div class="has_subclass_acc">
          <div data-toggle="collapse_slide" :data-target="'#item' + element.id" class="onleft_acc_arrow"
               data-class="accordion"></div>
          <span @click="editCategory(element)">{{ element.name }}</span>
        </div>
        <nested-draggable-chat-category
            :categories="element.sub_categories"
            :id="'item' + element.id"
            :child="true"
            @editCategory="editCategory"
            @changeSort="changeSort"
            class="sub_accordion default_accrodion Item_sort_child"
        />
      </li>
      <li v-else :class="[{'no_subclass_acc': !child}]">
        <div class="onleft_acc_arrow" v-if="!child"></div>
        <span @click="editCategory(element)">{{ element.name }}</span>
      </li>

    </template>
  </draggable>
</template>
<script>

import draggable from "vuedraggable"

export default {
  name: "nested-draggable-chat-category",
  components: {
    draggable,
  },
  props: {
    categories: {
      required: false,
      type: Array,
    },
    child: {
      required: false,
      type: Boolean,
      default: false
    },
  },
  methods: {
    editCategory(category) {
      this.$emit('editCategory', category)
    },
    changeSort(categories) {
      this.$emit('changeSort', categories)
    },
    hasChild() {
      this.$emit('update-prop-value', true);
    },
  }
};
</script>
<style>

</style>